import React from "react";

interface SkeletonProps {
  className?: string;
  variant?: "text" | "rectangular" | "circular";
  height?: number | string;
  width?: number | string;
  rows?: number;
}

/**
 * Skeleton component for loading states.
 * Provides animated placeholder content.
 */
export function Skeleton({
  className = "",
  variant = "rectangular",
  height,
  width,
  rows,
}: SkeletonProps) {
  const baseClasses = "animate-pulse bg-muted rounded";
  
  const variantClasses = {
    text: "h-4",
    rectangular: "",
    circular: "rounded-full",
  };

  const style: React.CSSProperties = {};
  if (height) style.height = typeof height === "number" ? `${height}px` : height;
  if (width) style.width = typeof width === "number" ? `${width}px` : width;

  if (rows && rows > 1) {
    return (
      <div className={`space-y-4 ${className}`}>
        {[...Array(rows)].map((_, i) => (
          <div
            key={i}
            className={`${baseClasses} ${variantClasses[variant]}`}
            // Only apply custom height/width styling to the first row
            style={i === 0 ? style : undefined}
          />
        ))}
      </div>
    );
  }

  return (
    <div
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
      style={style}
    />
  );
}
